<template>
   <div class="LogoImage">
      <img :src="src" :alt="source" />
      <div class="caption">{{ source }}</div>
    </div>
</template>

<script>
import './LogoImage.css';
export default {
  name: 'logo-image',
  props: {
    source: {
      type: String,
      default: '/img/email/_logo.png',
      required: true,
    },  
  },
  computed: {
    src() {
      return {
        [this.source]: !0,
      };
    },
  },


};
</script>
